import initAmbientVideo from './modules/ambientVideo.es6.js';

(() => {
  initAmbientVideo();
})();
